import { Http } from './http';
import { SyntageAuth } from '@types';

class SyntageAuthHttp extends Http {

  prefix = 'syntage_auth';

  async getAuth(userId: number): Promise<SyntageAuth | null> {
    const res = await this.get<SyntageAuth | null>(`/${userId}`);

    return res.data;
  }
}

export const syntageAuthHttp = new SyntageAuthHttp();

